export const CLIENT_SEARCH_SOURCE = "q";

const FILTER_LIMIT_SMALL = 100;
const FILTER_LIMIT_MEDIUM = 250;
const FILTER_LIMIT_LARGE = 500;

export const FILTER_LIMITS = [
  FILTER_LIMIT_SMALL,
  FILTER_LIMIT_MEDIUM,
  FILTER_LIMIT_LARGE,
];
export const FILTER_LIMIT_OPTIONS = FILTER_LIMITS.map((value) => ({
  id: value,
  name: value,
}));

const STATISTICS_PER_PAGE_SMALL = 50;
const STATISTICS_PER_PAGE_MEDIUM = 100;
const STATISTICS_PER_PAGE_LARGE = 200;

export const STATISTICS_PER_PAGE_OPTIONS = [
  STATISTICS_PER_PAGE_SMALL,
  STATISTICS_PER_PAGE_MEDIUM,
  STATISTICS_PER_PAGE_LARGE,
];

export const FILTER_BASE_PROPS: {
  alwaysOn: boolean;
  sx: {
    minWidth: string;
    maxWidth: string;
    minHeight: string;
    justifyContent: string;
  };
  helperText: false;
} = {
  alwaysOn: true,
  sx: {
    minWidth: "230px",
    maxWidth: "300px",
    minHeight: "48px",
    justifyContent: "center",
  },
  helperText: false,
};
